import React, { useEffect, useState } from "react";
import axios from "axios";
import "./GroupStyle.css";
import { useParams } from "react-router-dom";
import { Table, Spinner, Alert, Container } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";
import { Button, Col, FloatingLabel, Row, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { use } from "react";

function GroupsList() {
	const { key } = useParams(); // Example: verification-distributed
	const [groups, setGroups] = useState([]);

	useEffect(() => {
		const AuthToken = localStorage.getItem("AuthUser");
		axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

		axios
			.get(`${process.env.REACT_APP_API_URL}/act-group-details/${key}`)
			.then((response) => {
				if (response.data.success) {
					const allGroups = [
						...(response.data.data.total_groups || []),
						...(response.data.data.female_groups || []),
						...(response.data.data.male_groups || []),
					];

					setGroups(allGroups);
					console.log(response.data.data, "group details");
				}
			})
			.catch((error) => {
				console.error(error);
			});
	}, [key]);



	return (
		<>
			<PageLayout>
				<Row>
					<Col xl={12}>
						<div className="mc-card">
							<div className="mc-breadcrumb">
								<ul className="mc-breadcrumb-list">
									<li className="mc-breadcrumb-item">
										<Link
											to="#"
											className="mc-breadcrumb-link"
											style={{ color: "#077834" }}
										>
											{"home"}
										</Link>
									</li>

									<li className="mc-breadcrumb-item">
										<Link
											to="#"
											className="mc-breadcrumb-link"
											style={{ color: "#077834" }}
										>
											{"ACT Group Dashboard"}
										</Link>
									</li>

									<li className="mc-breadcrumb-item">
										{"Groups"}
									</li>
								</ul>
							</div>
						</div>
					</Col>
				</Row>
				<Container className="mt-4">
					<div style={{ overflowX: "auto" }}>
						<Table
							className="mc-table product"
							striped
							bordered
							hover
						>
							<thead className="mc-table-head ">
								<tr>
									<th>
										<div className="mc-table-check">#</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											City ID
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Address
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Group Name
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Gender
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Date
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Agreed Amount
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Saving Frequency
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Meeting Frequency
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Mobilizers
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Admission Form Status
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Saving Box Delivered
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Minute Book Delivered
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Pass Book Delivered
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											User ID
										</div>
									</th>
									<th>
										{" "}
										<div className="mc-table-check">
											Actions
										</div>
									</th>
								</tr>
							</thead>
							<tbody className="mc-table-body even">
								{Array.isArray(groups) && groups.length > 0 ? (
									groups.map((group, index) => (
										<tr key={group.id}>
											<td>
												{" "}
												<div className="mc-table-check">
													{index + 1}{" "}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.city_id}{" "}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.address}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.group_name}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.group_gender}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.date}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.agreed_amount}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.saving_frequency}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.meeting_frequency}
												</div>
											</td>
											<td>
												<div className="mc-table-check"><ul>
													{group.mobilizers && group.mobilizers.map((mob,index)=>(
                            <li key={index}> {index+1}- {mob} </li>
                          ))}
												</ul></div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{
														group.admission_from_status
													}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.saving_box_delivered}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{
														group.minute_book_delivered
													}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.pass_book_delivered}
												</div>
											</td>
											<td>
												{" "}
												<div className="mc-table-check">
													{group.user_id}
												</div>
											</td>

											<td className="eye-icon">
												{" "}
												<Link
													to={`/view-group-members/${group.id}`}
													state={{ group }}
												>
													<i
														className="material-icons view view-icon"
														style={{
															color: "white",
															borderRadius: "5px",
															backgroundColor:
																"rgba(7, 120, 52, 0.7)",
															padding: "2px 2px",
														}}
													>
														visibility
													</i>
												</Link>
											</td>
										</tr>
									))
								) : (
									<tr>
										<td
											colSpan="16"
											style={{ textAlign: "center" }}
										>
											No groups found
										</td>
									</tr>
								)}
							</tbody>
						</Table>
					</div>
				</Container>
			</PageLayout>
		</>
	);
}

export default GroupsList;
